import { jsxs, jsx } from 'react/jsx-runtime';
import style from './PageContainer.module.css.js';

const PageContainer = ({ children, title, }) => {
    return (jsxs("div", { className: style.container, children: [title && jsx("div", { className: style.title, children: title }), jsx("div", { className: style.contentContainer, children: children })] }));
};

export { PageContainer };
//# sourceMappingURL=PageContainer.js.map
